import request from '@/utils/request'

export function getZendeskToken() {
  return request(
    {
      path: '/merchants/zendesk-authenticate',
      method: 'POST',
    },
    {
      options: {
        hideMessage: true,
      },
    }
  )
}
